import React, { Fragment, useEffect, useState } from 'react'
import CheckIcon from '@assets/img/reservation/check-icon.svg'
import ChevronRight from '@assets/img/reservation/chevron-right.svg'
import classNames from 'classnames'
import { OFFER_COUNTRY_TYPE, STEPS } from './useReservation'
import { useReservationContext } from './ReservationContext'

const ProgressBar = () => {
    const { currentStep, offerCountryType, t } = useReservationContext()
    const [stepsOrder, setStepsOrder] = useState([
        { key: STEPS.PERSONAL_INFO, label: 'personal-data' },
        { key: STEPS.PARTICIPANTS, label: 'participants-data' },
        { key: STEPS.INSURANCE, label: 'insurance' },
        { key: STEPS.PARKING, label: 'parking' },
        { key: STEPS.PAYMENT, label: 'payment' },
    ])

    useEffect(() => {
        setStepsOrder(offerCountryType === OFFER_COUNTRY_TYPE.POLAND ? [
            { key: STEPS.PERSONAL_INFO, label: 'personal-data' },
            { key: STEPS.PARTICIPANTS, label: 'participants-data' },
            { key: STEPS.PAYMENT, label: 'payment' },
        ] : [
            { key: STEPS.PERSONAL_INFO, label: 'personal-data' },
            { key: STEPS.PARTICIPANTS, label: 'participants-data' },
            { key: STEPS.INSURANCE, label: 'insurance' },
            { key: STEPS.PARKING, label: 'parking' },
            { key: STEPS.PAYMENT, label: 'payment' },
        ])
    }, [offerCountryType])


    return (
        <span className="trip-reservation__bar">
            {stepsOrder.map((si, index) => {
                const currentIndex = stepsOrder.findIndex((s) => s.key === currentStep)

                return (
                    <Fragment key={si.key}>
                        <div
                            className={classNames('trip-reservation__bar-item', {
                                'trip-reservation__bar-item--filled': index < currentIndex,
                                'trip-reservation__bar-item--current': index === currentIndex,
                            })}
                        >
                            {index < currentIndex && <img src={CheckIcon} alt="check" />}
                            {t(si.label)}
                        </div>
                        {index < stepsOrder.length - 1 && <img src={ChevronRight} alt="chevron-right" />}
                    </Fragment>
                )
            })}
        </span>
    )
}

export default ProgressBar
